import styled, { css } from 'styled-components'

const BaseToast = styled.div`
  font-size: 1.4rem;
  padding: 1.3rem;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 30rem;
  height: 5rem;
  box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.3);
`

export const ToastContainer = styled.div<{ verticalPositionCenter: boolean }>`
  ${({ verticalPositionCenter }) => {
    if (verticalPositionCenter) {
      return css`
        display: flex;
        justify-content: center;
      `
    }

    return ''
  }}
`

export const MessageContainer = styled.div`
  width: 100%;
  margin: 0 1rem;
`

export const SuccessToast = styled(BaseToast)`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.background};
`

export const InfoToast = styled(BaseToast)`
  background-color: ${({ theme }) => theme.colors.modalBackground};
  color: ${({ theme }) => theme.colors.primaryLight};
`

export const WarningToast = styled(BaseToast)`
  background-color: ${({ theme }) => theme.colors.modalBackground};
  color: ${({ theme }) => theme.colors.danger};
`

export const ErrorToast = styled(BaseToast)`
  background-color: ${({ theme }) => theme.colors.danger};
  color: ${({ theme }) => theme.colors.background};
`
